export default __webpack_public_path__ + "static/media/people.8e3bde7f.png";